import type { Schema } from "@/shared/components/Form/types";
import { OrganizationsAutocompleteQuery } from "@/admin/entities/organizations";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";

export const filterSchema: Schema = {
  status: {
    label: "Статус",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все статусы", value: "" },
      { label: "Требует ответа", value: "NEEDS_RESPONSE" },
      { label: "Выигран", value: "WON" },
      { label: "Проигран", value: "LOST" },
      { label: "Закрыт", value: "CLOSED" },
    ],
  },
  organizationId: {
    label: "Организация",
    type: "autocomplete",
    query: OrganizationsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
};
